export const camelToKebab = (str: string): string =>
  // safari gives error since positive lookbehind
  //str.replace(/((?<=[a-z\d])[A-Z]|(?<=[A-Z\d])[A-Z](?=[a-z]))/g, '-$1').toLowerCase();
  str.replace(/([a-z])([A-Z])|[ ]/g, '$1-$2').toLowerCase();
